export { IntroController };
window.IntroController = IntroController;
function IntroController(guideData, fullScreenController, prepareEmbed) {
   var template = prepareEmbed(window.embedHbsTemplates('EMBED_V4_INTRO_HBS'));
   var element;

   function getElement(guide, isSingle) {
      if (element) {
         element.find('.js-prev').addClass('disabled');
         return element;
      }

      if (guide.flags.length) {
         guide.isDangerous = false;
         $.each(guide.flags, function(ndx, flag) {
            guide.isDangerous = flag.flagid == 'DANGER';
            if (guide.isDangerous) {
               guide.dangerousFlag = flag;
               // Break out of the loop if guide is dangerous
               return false;
            }
         });
      }

      // Only enable featured videos for dozuki sites since we promised video
      // support on launch. Remove this once we add full videojs support that
      // will hopefully come within the coming week or two.
      guide.showIntroVideo = App.siteName !== 'ifixit' && guide.intro_video_url;

      guide.introItemCount = guide.parts.length + guide.tools.length;
      guide.showButtonGroup = guide.introItemCount || guide.documents.length;
      guide.buttonClass = guide.introItemCount && guide.documents.length ? 'button-3' : 'button-2';
      guide.single_step = guide.steps.length === 1;

      // If the controls are hidden, we skip the title/image page
      // and start on the intro/parts/tools page, so we move the
      // title to that page instead of the static "Introduction"
      // title.

      guide.isOperatorView = App.hideControls;
      if (App.hideControls) {
         guide.pageTitle = _js('Overview');
      } else {
         guide.pageTitle = _js('Introduction');
      }
      guide.isSingle = isSingle;

      element = template(guide);
      element.find('.js-prev').addClass('disabled');

      if (!fullScreenController.supported()) {
         element.find('.js-fullscreen').hide();
      }
      element.find('.intro-section-button').click(function(e) {
         clearIntroState();
         $(this).addClass('active');

         clearIntroContent();
         showIntroContent($(this).context.attributes.rendercontent.value);
      });

      return element;
   }

   function clearIntroState() {
      element.find('.intro-section-button').removeClass('active');
   }

   function showIntroContent(renderTarget) {
      element.find('#' + renderTarget).removeClass('hidden');
   }

   function clearIntroContent() {
      element.find('.intro-content').addClass('hidden');
   }

   return {
      getElementImmediately: getElement,
      getElement: function() {
         return guideData
            .get()
            .then(function(guide) {
               return getElement(guide, true);
            })
            .reportErrors();
      },
   };
}

Handlebars.registerHelper('greaterThanOne', function(value, options) {
   return value > 1 ? options.fn(this) : options.inverse(this);
});
